<template>
  <div class="inner" style="margin-bottom: 80px">
    <el-container>
      <el-aside width="1.8rem">
          <layout-left></layout-left>
      </el-aside>
      <el-main>
          <router-view :key='$route.path'></router-view>
      </el-main>
    </el-container>
  </div>
</template>

<script>
import LayoutLeft from './components/layoutleft'
export default {
    components:
    {
       LayoutLeft
    }
};
</script>

<style>
.el-main{
  padding:0 20px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Personalcenter/personalDetails.vue